"use client"

import { useEffect, useState } from 'react'
import Link from 'next/link'
import Button from '@components/button/Button'
import Modal from '@components/modal/Modal'
import mutateUser from '@utils/user/mutateUser'
import withUser from '@hoc/withUser'
import { post } from '@api/apiFetcher'
import MessageHelper from '@utils/messageHelper'
import { LOGOUT_PAGE, PRIVACY_PAGE, REGULATIONS_PAGE } from '@constants/routes'
import { usePathname } from 'next/navigation'
import simpleDate from '@utils/date/simpleDate'
import Checkbox from '@components/form/Checkbox'
import { AGREEMENT_TEXTS, TERMS_VERSION } from '@constants/agreements'

const defaultApiPath = '/api/user/accept_new_regulations'
const allowedViews = [REGULATIONS_PAGE, PRIVACY_PAGE]
const newRegulationsEntryDate = new Date(TERMS_VERSION)

const AcceptRecentRegulationsModal = withUser(({ apiPath = defaultApiPath, user }: { apiPath: string, user: any }) => {
    const [open, setOpen] = useState(false)
    const [agreements, setAgreements] = useState({})

    const pathName = usePathname()
    const onAllowedView = allowedViews.some(path => pathName?.includes(path))
    // akceptacja bez zapisanej wersji (sprzed zapisu wersji) dotyczy regulaminu obowiązującego od TERMS_VERSION
    const acceptedVersion = user?.agreements?.terms_version || TERMS_VERSION
    const acceptedNewRegulations = user?.agreements?.accepts_privacy_policy_and_regulations && acceptedVersion === TERMS_VERSION
    const token = user?.token

    const onAgreement = (e) => {
        const { name, checked } = e?.target || {}
        setAgreements({ ...agreements, [name]: checked })
    }

    const onClose = () => setOpen(false)
    const onAccept = () => {
        const {
            accepts_privacy_policy_and_regulations,
            email_marketing,
            other_marketing,
        } = agreements || {} as any

        if (!accepts_privacy_policy_and_regulations) return MessageHelper.error('Zaznacz zgodę z regulaminem i polityką prywatności.')

        post({
            auth: token,
            data: agreements,
            path: apiPath
        })
        .then(res => {
            MessageHelper.summary(res)
            if (res.user) {
                mutateUser(user, res.user)
                onClose()
            }
        })
        .catch(err => console.log(err))
    }

    useEffect(() => {
        if (!user || onAllowedView || acceptedNewRegulations) return
        setOpen(true)
    }, [acceptedNewRegulations, onAllowedView, user])

    return (
        <Modal open={open} onClose={onClose} locked>
            <div style={{maxWidth:900,padding:20}}>
                <h2>Zmiana regulaminu i polityki prywatności</h2>

                <p>Informujemy, że od <b>{simpleDate(newRegulationsEntryDate)}</b> operatorem portalu jest Samochody.pl Sp. z o.o. (dotychczas: Polmarket.pl Sp. z o.o. Sp. k.).</p>

                <p>Właściciel pozostaje ten sam, zmienia się jedynie nazwa podmiotu.</p>

                <p>Aby dalej korzystać ze swojego konta, konieczne jest zapoznanie się i zaakceptowanie nowego Regulaminu oraz Polityki prywatności.</p>

                <br/>
                <div>
                    <Checkbox name="accepts_privacy_policy_and_regulations" jsx={<span>Oświadczam, że zapoznałem się i akceptuję treść <Link href={REGULATIONS_PAGE} target="_blank">Regulaminu</Link> i <Link href={PRIVACY_PAGE} target="_blank">Polityki Prywatności</Link>.</span>} onClick={onAgreement} required />
                    <Checkbox name="email_marketing" label={AGREEMENT_TEXTS.email_marketing} onClick={onAgreement} />

                    <Checkbox name="other_marketing" label={AGREEMENT_TEXTS.other_marketing} onClick={onAgreement} />
                </div>

                <br/><br/>
                <div style={{alignItems:'center',display:'flex',gap:20,justifyContent:'space-between'}}>
                    <Button onClick={onAccept} teal>Zaakceptuj</Button>
                    <Button href={LOGOUT_PAGE} white>Wyloguj</Button>
                </div>
            </div>
        </Modal>
    )
})

export {
    AcceptRecentRegulationsModal,
    newRegulationsEntryDate,
}